import { AggregationType, ModeEnum, type AggregationWithAccounts } from '@talos/kyoko';
import type { MarketSelectorPreset } from '../types';

/** Maps org trading aggregations (user type) to market selector presets. */
export function mapUserAggregationsToMarketSelectorPresets(
  aggregations: AggregationWithAccounts[] | undefined
): MarketSelectorPreset[] | undefined {
  if (!aggregations) {
    return undefined;
  }

  const userAggregations = aggregations.filter(agg => agg.AggregationType === AggregationType.User);

  return userAggregations.map(agg => {
    const relevantAggAccounts: string[] = [];
    for (const [, aggAcc] of agg.Accounts) {
      if (aggAcc.Mode === ModeEnum.Enabled && aggAcc.MarketAccount) {
        relevantAggAccounts.push(aggAcc.MarketAccount);
      }
    }

    return {
      id: agg.Name,
      label: agg.DisplayName ?? agg.Name,
      itemIDs: relevantAggAccounts,
    } satisfies MarketSelectorPreset;
  });
}
